var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPurpleQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#802DF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30273 11.3867H10.3281V11.0059C10.3281 10.3906 10.5391 10.0625 11.2832 9.62305C12.0332 9.17188 12.5078 8.52148 12.5078 7.60742V7.5957C12.5078 6.39453 11.5 5.48047 10.0234 5.48047C8.37695 5.48047 7.5332 6.48828 7.46875 7.74805V7.75977L8.46484 7.75391L8.47656 7.74805C8.53516 6.91602 9.09766 6.39453 9.98242 6.39453C10.8555 6.39453 11.418 6.92773 11.418 7.64844V7.66016C11.418 8.28125 11.1543 8.65039 10.4746 9.06641C9.67188 9.54688 9.29688 10.0742 9.30273 10.8477V11.3867ZM9.89453 14.1055C10.3691 14.1055 10.7031 13.7656 10.7031 13.291C10.7031 12.8105 10.3691 12.4707 9.89453 12.4707C9.41992 12.4707 9.08008 12.8105 9.08008 13.291C9.08008 13.7656 9.41992 14.1055 9.89453 14.1055Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPurpleQuestion);
export default __webpack_public_path__ + "static/media/ic_purple_question.2616934c36375586e9bc77f7ec93b6f4.svg";
export { ForwardRef as ReactComponent };